import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from "@sentry/react";
import * as cobo from "@cobo-screenshot/sdk";
import App from './App'
import './index.css'
import { installDomSafetyGuards } from './lib/domSafetyGuards'

installDomSafetyGuards()

Sentry.init({
  dsn: "https://db7e5ff32c7833247bc8ce0c39c1c76c@o4509438656774144.ingest.us.sentry.io/4510497263517696",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

cobo.init({ workspaceId: "fec32bca-b2f0-4f3c-b4ce-163827911293" })

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
